import { ResizeMode } from '../constants/resize';
import { isSomeEnum } from './isSomeEnum';

export const isResizeMode = isSomeEnum(ResizeMode);
